import styled from 'styled-components';

export const Container = styled.div`
    padding: 10px;
`;

export const Buttons = styled.div`
    button{
        width: auto;
        padding: 0 15px;
        background: #efefef;
        border: none;

        &.load{
            background: var(--blueColor1);
            color:#fff;
        }

        &.save{
            background: var(--purpleColor1);
            color:#fff;
        }

        &.initialize{
            background: var(--redColor1);
            color:#fff;
        }
    }
`;

export const Body = {
    Container: styled.div`
        margin-top: 20px;
    `,
    Wrapper: styled.div`
        display: flex;
        flex-direction: row;
        gap: 10px;

        @media all and (max-width:992px){
            flex-direction: column;
        }
    `,
    Card: styled.div`
        flex:1;
        text-align: center;
        border: 1px solid #e0e0e0;
        padding: 20px 10px;
        display: flex;
        flex-direction: column;
        gap: 20px;
        border-radius: 10px;

        .label{
            font-size: 18px;
            font-weight: 600;
        }

        .data{
            font-size: 14px;
            font-weight: 600;
        }
    `,
}